import React from 'react';
import Carousel from '../components/Carousel';
import Navbar from '../components/Navbar';
import '../styles/Home.css';
import HomeButton from '../components/HomeButton';
import ConstructionPopup from '../components/ConstructionPopup';

const Home = () => {
    return (
        <div className="home-hero">
            <ConstructionPopup />
            <div className="home-hero__bg">
                <Carousel />
            </div>
            <div className="home-hero__content">
                <HomeButton />
                <Navbar />
            </div>
        </div>
    );
};

export default Home;

//Vyh74pnbGbZZ1uqY : password for supabase DB